"use client";

import { useSyncExternalStore } from "react";

import { isInstalledPwa } from "@/lib/pwa-refresh.mjs";

function subscribe(onChange: () => void) {
  const media = window.matchMedia?.("(display-mode: standalone)");
  media?.addEventListener("change", onChange);
  return () => media?.removeEventListener("change", onChange);
}

export function usePwa() {
  return useSyncExternalStore(subscribe, isInstalledPwa, () => false);
}
